import { ArrowLeftIcon } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";
import { cn } from "@/core/shared/v2/lib/utils";

type BackButtonProps = {
  onClick: () => void;
  className?: string;
};

export const BackButton = ({ onClick, className }: BackButtonProps) => {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      className={cn(
        "flex items-center gap-1 border-b text-gray-600 text-sm transition-colors hover:text-gray-900",
        className,
      )}
      onClick={onClick}
    >
      <ArrowLeftIcon className="size-4" />
      {t("GROUP_ACTIONS_ORDERING.GENERAL.BACK")}
    </button>
  );
};
